// src/api/reportesApi.js
export const REPORTES_API =
  process.env.REACT_APP_REPORTES_API ||
  "https://x7ur7541m7.execute-api.us-east-1.amazonaws.com/dev";
